import {cx} from '@emotion/css';
import {FontSize, FontWeight, TextAlignment} from '@fo/shared/styles/variables/fonts';
import React, {ReactElement, ReactNode, RefObject} from 'react';

import styles from './Paragraph.styles';

export interface ParagraphProps {
  alignment?: TextAlignment;
  children?: ReactNode;
  className?: string;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  italic?: boolean;
  id?: string;
  ref?: React.RefObject<HTMLParagraphElement>;
  testId?: string;
}

const Paragraph = React.forwardRef(
  ({alignment, children, className, fontSize, fontWeight, italic, id, testId}: ParagraphProps, ref): ReactElement => (
    <p
      className={cx(styles.paragraph(alignment, fontSize, fontWeight, italic), className)}
      id={id}
      ref={ref as RefObject<HTMLParagraphElement>}
      data-testid={testId}
    >
      {children}
    </p>
  )
);

export default Paragraph;
